<ng-container *ngIf="!isInErrorState()">
    <div class="container webmail-password"
         *ngIf="template === eTEMPLATE.INVITATION">
        <div class="webmail-password__logo">
            <img [src]="'/assets/images/ui/tools/ik-mail.svg'"
                 alt="Infomaniak Mail" />
            <div class="webmail-password__brand">
                <span>Infomaniak</span>
                <span>Mail</span>
            </div>
        </div>
        <div class="webmail-password__content">
            <p class="webmail-password__content__title">{{'Avant de commencer la configuration' | transloco }},<br><span
                      [innerHTML]="'creez un mot de passe pour l\'adresse <strong>$mail$</strong>' | transloco: {mail: (mail | escapeHtml)} "></span>
            </p>
            <form [formGroup]="form"
                  class="form margin-top-50 margin-bottom-40">
                <ik-password-input [iconSeePassword]="'icon-eye'"
                                   [iconHidePassword]="' icon-eye-crossed'"
                                   [iconGeneratePassword]="'icon-rotation-lock'"
                                   [classes]="'ik-form-field ik-form-field--bigger password-field'"
                                   [label]="'Mot de passe' | transloco"
                                   [minLength]="8"
                                   [showGenerate]="true"
                                   (generate)="generate($event)"
                                   formControlName="password"
                                   matInput
                                   name="password"
                                   [placeholder]="'Mot de passe' | transloco"
                                   type="text"
                                   autocomplete="password">
                </ik-password-input>
                <div class="margin-bottom-30 margin-top-30 validation">
                    <ik-validation-check [label]="'a'"
                                         [description]="'Minuscule' | transloco"
                                         [tooltipMessage]="'Au moins une minuscule' | transloco"
                                         [valid]="passwordValidation.lowerCase">
                    </ik-validation-check>
                    <ik-validation-check [label]="'A'"
                                         [description]="'Majuscule' | transloco"
                                         [tooltipMessage]="'Au moins une majuscule' | transloco"
                                         [valid]="passwordValidation.upperCase">
                    </ik-validation-check>
                    <ik-validation-check [label]="'0-9'"
                                         [description]="'Chiffre' | transloco"
                                         [tooltipMessage]="'Au moins un chiffre' | transloco"
                                         [valid]="passwordValidation.number">
                    </ik-validation-check>
                    <ik-validation-check [label]="'8+'"
                                         [description]="'Caracteres' | transloco"
                                         [tooltipMessage]="'$number$ caracteres ou plus' | transloco:{number: 8}"
                                         [valid]="passwordValidation.characterCount">
                    </ik-validation-check>
                </div>
                <mat-error *ngIf="form.get('password').hasError('maxlength')"> *
                    {{ 'La taille maximum de ce champ est de 72 caracteres' | transloco}}
                </mat-error>
                <mat-error *ngIf="displayFormError"
                           [innerHTML]="getValidationErrorMessage()"
                           class="hintError"></mat-error>
            </form>
            <div class="webmail-password__message margin-bottom-60">
                <p>{{'Ce mot de passe vous sera demande pour vous connecter a votre adresse mail.' | transloco}}</p>
                <p
                   [innerHTML]="'Vous pourrez a tout moment modifier votre mot de passe dans vos <strong>Parametres de securite</strong>.' | transloco">
                </p>
            </div>
            <div>
                <div class="xs-align-center bottom-xs-20">
                    <button (click)="acceptInvitation()"
                            mat-raised-button
                            class="mat-elevation-z"
                            color="primary"
                            [disabled]="form.invalid"
                            [buttonLoader]="loading">
                        {{'Configurer mon adresse' | transloco}}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="container webmail-password webmail-password__recover align-center"
         *ngIf="template === eTEMPLATE.RECOVER || template === eTEMPLATE.RECOVER_UNIFIED">
        <div class="webmail-password__content"
             *ngIf="success === false">
            <p class="fontMediumLarge grey-darken-4 align-left bold">
                {{'Reinitialisation de votre mot de passe' | transloco }}
            </p>
            <div class="align-left grey-darken-3 fontMediumSmall"
                 [innerHTML]="(template === eTEMPLATE.RECOVER ?
                  ('Veuillez choisir un nouveau mot de passe pour votre adresse mail' | transloco ) :
                  ('Veuillez choisir le nouveau mot de passe que vous utiliserez pour vous connecter a votre compte (Manager) et pour consulter votre adresse mail' | transloco ))
                  + ' :'"></div>
            <div class="padding-top-20 bold align-left">{{mail}}</div>
            <form [formGroup]="form"
                  class="form margin-top-30 margin-bottom-40 flex-column">
                <ik-password-input [iconSeePassword]="'icon-eye'"
                                   [iconHidePassword]="' icon-eye-crossed'"
                                   [iconGeneratePassword]="'icon-rotation-lock'"
                                   [classes]="'ik-form-field ik-form-field--bigger password-field'"
                                   [label]="'Nouveau mot de passe' | transloco"
                                   [minLength]="8"
                                   [showGenerate]="true"
                                   (generate)="generate($event)"
                                   formControlName="password"
                                   matInput
                                   name="password"
                                   [placeholder]="'Nouveau mot de passe' | transloco"
                                   type="text"
                                   autocomplete="password">
                </ik-password-input>
                <div class="margin-bottom-30 margin-top-30 validation">
                    <ik-validation-check [label]="'a'"
                                         [description]="'Minuscule' | transloco"
                                         [tooltipMessage]="'Au moins une minuscule' | transloco"
                                         [valid]="passwordValidation.lowerCase">
                    </ik-validation-check>
                    <ik-validation-check [label]="'A'"
                                         [description]="'Majuscule' | transloco"
                                         [tooltipMessage]="'Au moins une majuscule' | transloco"
                                         [valid]="passwordValidation.upperCase">
                    </ik-validation-check>
                    <ik-validation-check [label]="'0-9'"
                                         [description]="'Chiffre' | transloco"
                                         [tooltipMessage]="'Au moins un chiffre' | transloco"
                                         [valid]="passwordValidation.number">
                    </ik-validation-check>
                    <ik-validation-check [label]="'8+'"
                                         [description]="'Caracteres' | transloco"
                                         [tooltipMessage]="'$number$ caracteres ou plus' | transloco:{number: 8}"
                                         [valid]="passwordValidation.characterCount">
                    </ik-validation-check>
                </div>
                <mat-error *ngIf="form.get('password').hasError('maxlength')"> *
                    {{ 'La taille maximum de ce champ est de 72 caracteres' | transloco}}
                </mat-error>
                <mat-error *ngIf="displayFormError"
                           [innerHTML]="getValidationErrorMessage()"
                           class="hintError padding-bottom-20"></mat-error>
                <ik-password-input [iconSeePassword]="'icon-eye'"
                                   [iconHidePassword]="' icon-eye-crossed'"
                                   [classes]="'ik-form-field ik-form-field--bigger password-field'"
                                   [label]="'Confirmation du mot de passe' | transloco"
                                   [minLength]="8"
                                   [showGenerate]="false"
                                   formControlName="confirmPassword"
                                   matInput
                                   name="confirmPassword"
                                   [placeholder]="'Confirmation du mot de passe' | transloco"
                                   type="text"
                                   autocomplete="confirmPassword">
                </ik-password-input>
                <mat-error class="padding-top-10"
                           *ngIf="form.hasError('notMatching')"> * {{ 'Les mots de passe sont differents' | transloco}}
                </mat-error>
            </form>
            <div>
                <div class="xs-align-center bottom-xs-20 padding-top-20">
                    <button (click)="acceptRecover()"
                            mat-raised-button
                            class="mat-elevation-z"
                            color="primary"
                            [disabled]="loading || form.invalid"
                            [buttonLoader]="loading">
                        {{'Enregistrer et continuer' | transloco}}
                    </button>
                </div>
            </div>
        </div>
        <div class="webmail-password__content flex flex-column"
             *ngIf="success === true">
            <p class="fontMediumLarge grey-darken-4 align-left">{{'Votre mot de passe a bien ete modifie' | transloco }}
            </p>
            <div class="connexion-info margin-bottom-20">
                <p class="align-left">
                    <strong class="align-left">{{'Vos nouveaux identifiants de connexion' | transloco}} :</strong></p>
                <p class="connexion-info__data__email fontMediumSmall"><span>{{'Identifiant' | transloco}} :
                    </span><strong class="ellipsis">{{ mail }}</strong></p>
                <div class="connexion-info__data__password-block">
                    <span
                          class="connexion-info__data__password-block__password grey-darken-4">{{'Mot de passe' | transloco}}
                        :&nbsp;</span>
                    <input class="connexion-info__data__password-block__input black"
                           disabled
                           #passwordField
                           type="{{inputType}}"
                           value="{{form.get('password').value}}">
                    <div class="connexion-info__data__password-block__buttons">
                        <button class="icon icon-eye icon-size-14"
                                [tooltip]="'Afficher le mot de passe' | transloco"
                                (click)="switchInputType()"></button>
                        <button class="icon icon-copy icon-size-14"
                                [tooltip]="'Copier le mot de passe' | transloco"
                                ngxClipboard
                                [cbContent]="passwordField.value"
                                (cbOnSuccess)="copied()"></button>
                    </div>
                </div>
            </div>
            <div>
                <span class="icon icon-smartphone grey-darken-3 icon-size-20 padding-right-15"></span>
                <span class="icon icon-laptop grey-darken-3 icon-size-20"></span>
            </div>
            <div class="align-left line-height-20 grey-darken-3 margin-top-15">
                <span
                      [innerHTML]="'Les appareils qui se connectent a cette adresse mail vont vous demander ce nouveau mot de passe. Pensez a la mettre a jour partout (<strong>vraiment partout</strong>).'  | transloco">
                </span>
                <div (click)="openFaqSync()"
                     class="link blue">
                    {{'Comment faire ?'  | transloco}}
                </div>
            </div>
            <div class="xs-align-center bottom-xs-20 padding-top-60">
                <button (click)="endRecover()"
                        mat-raised-button
                        class="mat-elevation-z"
                        color="primary"
                        [disabled]="loading || form.invalid"
                        [buttonLoader]="loading">
                    {{'J\'ai termine' | transloco}}
                </button>
            </div>
        </div>
    </div>
</ng-container>
<signup-errors *ngIf="isInErrorState()"></signup-errors>
